import { render, staticRenderFns } from "./GetCompanyComponent.vue?vue&type=template&id=9965c9e8&scoped=true&"
import script from "./GetCompanyComponent.vue?vue&type=script&lang=js&"
export * from "./GetCompanyComponent.vue?vue&type=script&lang=js&"
import style0 from "./GetCompanyComponent.vue?vue&type=style&index=0&id=9965c9e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9965c9e8",
  null
  
)

export default component.exports